import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject, Observable, Subscription } from "rxjs";
import { HttpClient } from '@angular/common/http';

import { StorageService } from "../storage/storage.service";
import * as settings from "../../lib/api-constant";
import { DndPortalPoint } from "../../lib/api-constant";

import { IFiltersCriteria, IFilterValues, ISelectedFilters } from "../../lib/types/selectedFilters";
import { Router } from "@angular/router";


@Injectable({
    providedIn: "root",
})

export class FilterServiceUnMapped {
    private filterVisibilitySource = new BehaviorSubject<any>([]);
    filterVisibility$ = this.filterVisibilitySource.asObservable();

    private paginationStateSource = new BehaviorSubject<any>([]);
    public $paginationState = this.paginationStateSource.asObservable();
    private subscription = new Subscription();

    find(arg0: (item: any) => boolean) {
        throw new Error("Method not implemented.");
    }
    public filterVisibilitySubject = new Subject<boolean>();
    public companySelectionSubject = new BehaviorSubject<string>('');
    public filterSelectionDownloadOption = new BehaviorSubject<string>('');
    public $companyChanged = this.companySelectionSubject.asObservable();

    private filterSelection: ISelectedFilters = null;
    private filterSelectionPromise = new BehaviorSubject<ISelectedFilters>(
        this.filterSelection
    );
    public $filterSelection = this.filterSelectionPromise.asObservable();

    // public static assignedCompanies = [];

    public isKpiIndicatorsCalled: boolean = false;
    // public staticKpiCardData = [];

    private keyRefPromise = new BehaviorSubject<any>({
        key: 'bdpReferenceNumber',
        label: 'Shipment Number',
        value: '',
        shortLabel: 'Shipment Number',
        keyIndex: 1
    });
    public $keyRef = this.keyRefPromise.asObservable();

    public isShowFilterActivePromise = new BehaviorSubject<boolean>(false);
    public $isShowFilterActive = this.isShowFilterActivePromise.asObservable();

    private ListViewFilterPromise = new BehaviorSubject<ISelectedFilters>(this.filterSelection);
    public $ListViewFilter = this.ListViewFilterPromise.asObservable();

    private ContractCreationFilterPromise = new BehaviorSubject<ISelectedFilters>(this.filterSelection);
    public $ContractCreationFilter = this.ContractCreationFilterPromise.asObservable();

    private ContractApprovalFilterPromise = new BehaviorSubject<ISelectedFilters>(this.filterSelection);
    public $ContractApprovalFilter = this.ContractApprovalFilterPromise.asObservable();

    private ETAThresholdPromise = new BehaviorSubject<any>({ minLimit: -5, maxLimit: 5, etaConfigType: 1 });
    public $ETAThreshold = this.ETAThresholdPromise.asObservable();

    public bdpRepListPromise = new BehaviorSubject<any>([]);
    public $bdpRepListPromise = this.bdpRepListPromise.asObservable();

    public vesselNameListPromise = new BehaviorSubject<any>([]);
    public $vesselNameListPromise = this.vesselNameListPromise.asObservable();

    private metricFilterPromise = new BehaviorSubject<any>(null); // Created a behaviour subject 
    public $metricFilterPromise = this.metricFilterPromise.asObservable();
    public $threePLScreenEnabled = new Subject<boolean>();


    constructor(
        private storageService: StorageService,
        // private backGroundJobService: BackgroundJobService,
        private http: HttpClient,
        private router: Router) {
        this.filterSelection = this.storageService.getItem("filters");
        if (this.filterSelection) {

            // if (this.checkIfEmpty(this.filterSelection)) {
            //     this.updateFilterSelection(this.filterSelection, "filterService");
            //     this.filterSelectionDownloadOption.next('applies');
            // }
        };
        // this.http.get(settings.UserEndPoint.CommonService.COMPANY).subscribe((res: any) => {
        //     if (res)
        //         FilterService.assignedCompanies = res;
        // });

    }

    // updateAssignedCompanies(companies: any) {
    //   FilterServiceService.assignedCompanies = companies;
    // }

    isStatusFilterSelected(selectedFilter: ISelectedFilters) {
        // if (selectedFilter['statusType']?.length === 0)
        //     return false;
        // else
        //     return true;
    }

    updateShowFilter(status: boolean) {
        this.isShowFilterActivePromise.next(status);   // To update the filter visibility
    }
    
    changeFilterVisibility(visibility: any) {
        const visibilityData = typeof visibility === 'boolean'
            ? { filterVisibility: visibility, url: this.router.url }
            : visibility;

        this.filterVisibilitySource.next(visibilityData);
    }
    // checkIfEmpty(filterSelection): boolean {
    //     let ifEmpty = false
    //     for (const filter in filterSelection) {
    //         if (filter == 'companies') { }
    //         else {
    //             if (filterSelection[filter].length > 0) {
    //                 ifEmpty = true
    //             }
    //         }
    //     }
    //     return ifEmpty
    // }

    getETAThreshold(params: any = {}) {
        return new Promise((resolve: any, reject: any) => {
            this.http.get(
                settings.UserEndPoint.UserPortal.GET_ETA_THRESHOLD,
                params
            ).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    setETAThreshold(body: any = {}) {
        this.storageService.setItem('eta_threshold', body);
        this.ETAThresholdPromise.next(body);
        return this.http.post(settings.UserEndPoint.UserPortal.SET_ETA_THRESHOLD, body);
    }

    public changeCompanySelection(company: any) {
        this.companySelectionSubject.next(company);
        this.filterSelectionDownloadOption.next('');
    }

    public paginationState(paginationState: any) {
        this.paginationStateSource.next(paginationState);
    }

    public updateListViewFilter(filterSelection: ISelectedFilters) {
        this.ListViewFilterPromise.next(filterSelection);
    }

    public updateFilterSelection(filterSelection: any, calledFrom: string): void {
        if (filterSelection === 'noFilter') {
            return; // Early return to reduce nesting
        }

        if (filterSelection) {
            const filterSelected: IFiltersCriteria = this.getIds(filterSelection);
            const backgroundJobData = JSON.parse(JSON.stringify(filterSelected));
            // this.backGroundJobService.preparingBackgroundJob(backgroundJobData);
        }

        this.filterSelection = filterSelection;
        this.filterSelectionPromise.next(filterSelection);
    }

    // public isStatusTypeFilterSelectedOnly(selectedFilters, filter) {
    //     if (selectedFilters[filter] !== '') {
    //         // Check if other filters are empty
    //         for (let key in selectedFilters) {
    //             if (key !== 'statusType' && key !== 'companies') {
    //                 if ((Array.isArray(selectedFilters[key]) && selectedFilters[key].length > 0)
    //                     || (typeof selectedFilters[key] === 'number' && selectedFilters[key] !== 0)
    //                 ) {
    //                     return false; // Other filters are not empty
    //                 }
    //             }
    //             else if (key === 'statusType' && selectedFilters[key].length == 0) {
    //                 return false; // 'statusType' or 'companies' filter is empty
    //             }
    //         }
    //         return true; // statusType and companies are present, and other filters are empty
    //     }
    //     return false;
    // }

    //To update the metric filter value so that it can be used anywhere needed.
    public updateMetricFilter(metricFilterSelection: any) {
        this.metricFilterPromise.next(metricFilterSelection);
    }

    public updateKeyRef(keyRef: string) {
        const keyRefObj = {
            key: 'bdpReferenceNumber',
            label: 'Shipment Number',
            value: '',
            shortLabel: 'Shipment Number',
            keyIndex: keyRef
        };
        switch (keyRef) {
            case '2': {
                keyRefObj.key = 'orderNumber';
                keyRefObj.label = 'Shipper Ref.  ';
                keyRefObj.shortLabel = 'Shipper Ref.  ';
                break;
            }
            case '3': {
                keyRefObj.key = 'purchaseOrderNumber';
                keyRefObj.label = 'PO Ref.  ';
                keyRefObj.shortLabel = 'PO Ref.   ';
                break;
            }
            case '4': {
                keyRefObj.key = 'bolAWBNumber';
                keyRefObj.label = 'BOL AWB  ';
                keyRefObj.shortLabel = 'BOL AWB  ';
                break;
            }
            case '5': {
                keyRefObj.key = 'bookingNumber';
                keyRefObj.label = 'Booking  ';
                keyRefObj.shortLabel = 'Booking  ';
                break;
            }
            // US#5420 Updating value for key referenc Container Number(s) 
            case '6': {
                keyRefObj.key = 'containerNumber';
                keyRefObj.label = 'Container #(s) ';
                keyRefObj.shortLabel = 'Container #(s): ';
                break;
            }
            default: {
                keyRefObj.key = 'bdpReferenceNumber';
                keyRefObj.label = 'Shipment Number  ';
                keyRefObj.shortLabel = 'Shipment Number  ';
                break;
            }
        }
        this.keyRefPromise.next(keyRefObj);
    }

    public updateETAThreshold(ETAThreshold: string) {
        this.storageService.setItem('eta_threshold', ETAThreshold);
        this.ETAThresholdPromise.next(ETAThreshold);
    }

    public getIds(selectedFilters: ISelectedFilters) {
        const filters: IFiltersCriteria = {
            originRegion: [],
            originCountry: [],
            portOfDeparture: [],
            destinationRegion: [],
            destinationCountry: [],
            portOfArrival: [],


            // shipmentPeriod:
            // {
            //     startRange: -5,
            //     endRange: 5
            // }
        };
        // if (selectedFilters) {
        //     for (let filter in filters) {
        //         if (filter == "shipmentPeriod") { }
        //         else {
        //             if (Array.isArray(selectedFilters[filter])) {
        //                 if (selectedFilters[filter][0] == "" && selectedFilters[filter].length > 1) {
        //                     selectedFilters[filter].pop();
        //                 }
        //                 if (selectedFilters[filter].length) {
        //                     filters[filter] = selectedFilters[filter].map(
        //                         (filter: IFilterValues) => {
        //                             return filter && filter.id ? filter.id : filter;
        //                         }
        //                     );
        //                 } else {
        //                     //  filters[filter]=[""];
        //                 }
        //             } else {
        //                 switch (typeof selectedFilters[filter]) {
        //                     case "object": {
        //                         filters[filter] = [selectedFilters[filter].id];
        //                         break;
        //                     }
        //                     case "number": {
        //                         filters[filter] = selectedFilters[filter];
        //                         break;
        //                     }
        //                     case "string": {
        //                         if (filter === 'statusType') {
        //                             // Handle statusType string case here
        //                             filters[filter] = selectedFilters[filter];
        //                         } else {
        //                             // For other string cases
        //                             filters[filter] = [];
        //                             filters[filter].push(selectedFilters[filter]);
        //                         }
        //                         break;
        //                     }
        //                     default: {
        //                         // if (selectedFilters[filter] && selectedFilters[filter].length == 0) {
        //                         //     // filters[filter] = [""];
        //                         // }
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // }
        return filters;
    }

    setFavorite(body: any) {
        let url = DndPortalPoint.ListView.SET_FAOURITE;
        return this.http.post(url, body);
    }


    setSavedFilters(body: any) {
        let url = DndPortalPoint.ListView.SET_SAVED_FILTERS;
        return this.http.post(url, body);
    }
    getSavedFilters() {
        let url = DndPortalPoint.ListView.GET_SAVED_FILTERS;
        return this.http.get(url);
    }
    setSavedUnmappedFilters(body: any) {
        let url = DndPortalPoint.Unmapped.SET_SAVED_FILTERS_UNMAPPED;
        return this.http.post(url, body);
    }
    getSavedUnmappedFilters() {
        let url = DndPortalPoint.Unmapped.GET_SAVED_FILTERS_UNMAPPED;
        return this.http.get(url);
    }

    getRegionCountryList(selectFilter: IFiltersCriteria): Observable<any> {
        return this.http.get(settings.UserEndPoint.CommonService.ORIG_REGION_COUNTRY);
    }

    getPortList(): Observable<any> {
        return this.http.get(DndPortalPoint.DndCommonEndppoint.PORT_LIST);
    }

    getContainerType(): Observable<any> {
        return this.http.get(DndPortalPoint.DndCommonEndppoint.CONTAINER);
    }
    getPorts(): Observable<any> {
        return this.http.get(DndPortalPoint.DndCommonEndppoint.PORTS);
    }
    getCarrier(): Observable<any> {
        return this.http.get(DndPortalPoint.DndCommonEndppoint.CARRIER);
    }
    getBdpRepresentative(): Observable<any> {
        return this.http.get(DndPortalPoint.DndCommonEndppoint.REPRESENTATIVE);
    }






}
